import * as $ from 'jquery';

export default (
    function() {
        $("#select-location-country").change(function() {
            if($(this).val() === "IN"){
                $("#location-state-field").show();
            } else {
                $("#location-state-field").hide();
                $("#select-state").val("").change();
            }
        });
        $( document ).ready(function() {
            if($("#select-location-country").val() === "IN") {
                $("#location-state-field").show();
            }
        });
    }()
);
